/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * bdk/v2/services/library.proto
 * OpenAPI spec version: version not set
 */

export type Bdkv2ConceptScalarType =
  (typeof Bdkv2ConceptScalarType)[keyof typeof Bdkv2ConceptScalarType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Bdkv2ConceptScalarType = {
  ConceptScalarTypeConceptual: 'ConceptScalarTypeConceptual',
  ConceptScalarTypeText: 'ConceptScalarTypeText',
  ConceptScalarTypeNumber: 'ConceptScalarTypeNumber',
  ConceptScalarTypeBoolean: 'ConceptScalarTypeBoolean',
  ConceptScalarTypeDatetime: 'ConceptScalarTypeDatetime',
  ConceptScalarTypeDate: 'ConceptScalarTypeDate',
  ConceptScalarTypeTime: 'ConceptScalarTypeTime',
  ConceptScalarTypeFile: 'ConceptScalarTypeFile',
  ConceptScalarTypeUUID: 'ConceptScalarTypeUUID',
} as const;
